import type { Recipe } from "@type/recipe";
import { create } from "zustand";

export enum RecipeCategoryEnum {
  DIET = "DIET",
  VARITY = "VARITY",
  KITCHEN = "KITCHEN",
  MOMENT = "MOMENT",
  SEASON = "SEASON",
}

export function translateFilters(cat: RecipeCategoryEnum) {
  switch (cat) {
    case RecipeCategoryEnum.DIET:
      return "Dieet";
    case RecipeCategoryEnum.VARITY:
      return "Variëteit";
    case RecipeCategoryEnum.KITCHEN:
      return "Keuken";
    case RecipeCategoryEnum.MOMENT:
      return "Moment";
    case RecipeCategoryEnum.SEASON:
      return "Seizoen";
  }
}

export const RECIPE_CATEGORY_FILTER = [
  RecipeCategoryEnum.DIET,
  RecipeCategoryEnum.VARITY,
  RecipeCategoryEnum.KITCHEN,
  RecipeCategoryEnum.MOMENT,
  RecipeCategoryEnum.SEASON,
] as const;
interface RecipeFilterState {
  filters: RecipeFilterItemType[];
  filterRecipes: (recipes: Recipe[]) => Recipe[];
  updateFilters: (filterItems: RecipeFilterItemType[]) => void;
}

export type RecipeFilterItemType = {
  id: number;
  name: string;
  category: RecipeCategoryEnum;
};

const initialFilters: RecipeFilterItemType[] = [];
// try {
//   const recipesFilterJSON = storage.getString("recipes-filter");
//   initialFilters = JSON.parse(recipesFilterJSON!) as RecipeFilterItemType[];
// } catch (e) {
//   console.log(e);
// }

export const useRecipeFilterStore = create<RecipeFilterState>((set, get) => ({
  filters: initialFilters,

  filterRecipes: (recipes) => {
    return recipes.filter((r) => {
      return get().filters.every((filter) => {
        switch (filter.category) {
          case RecipeCategoryEnum.DIET:
            return r.diets.some((d) => d.id === filter.id);
          case RecipeCategoryEnum.VARITY:
            return r.varities.some((d) => d.id === filter.id);
          case RecipeCategoryEnum.KITCHEN:
            return r.kitchens.some((d) => d.id === filter.id);
          case RecipeCategoryEnum.MOMENT:
            return r.moments.some((d) => d.id === filter.id);
          case RecipeCategoryEnum.SEASON:
            return r.seasons.some((d) => d.id === filter.id);
        }
      });
    });
  },
  updateFilters: (updatedFilters) => {
    set({ filters: updatedFilters });
    // const productsFiltersStringified = JSON.stringify(updatedFilters);
    // storage.set("recipes-filter", productsFiltersStringified);
  },
}));

export function useRecipeFilters() {
  return useRecipeFilterStore((store) => store.filters);
}
export function getRecipeFilters() {
  return useRecipeFilterStore.getState().filters;
}
